import React, { useRef } from 'react';

import { Form } from 'antd'
import cn from 'classnames';

import { Popover } from '@element/index';
import useClient from '@lib/hooks/useClient';
import I18n from '@utils/i18n';

// import { useLeverage } from '@widget/financial/AIP/List/hooks';
import { FormInputNumber } from '../FormInputNumber';
// import { FormMarginOption } from '../FormMarginOption';
import { FormSlider } from '../FormSlider';

import styles from './index.module.css';

export const BaseForm = (props) => {
  const {
    form,
    onFocus,
    beformItems,
    initialValues,
    afterItems,
    buyOrSellLabel,
    baseCurrency,
    quoteCurrency,
    onBaseQtyChange,
    onOrderTotalChange,
    onSlider,
    // onMarginSelected,
    // getMarginDisabled,
    onFinish,
    validState
  } = props
  // const { isLeverage } = useLeverage();
  return (
    <Form
      className={styles.form}
      form={form}
      initialValues={{ price: null, count: null, marginSelected: false, progress: 0, ...initialValues }}
      onFinish={onFinish}
    >
      {beformItems}
      <FormInputNumber
        name="baseQty"
        suffix={baseCurrency}
        prefix={buyOrSellLabel}
        onFocus={onFocus}
        onChange={onBaseQtyChange}
        fieldValid={{
          validateStatus: validState?.amountStatus,
          help: validState?.errorMsgAmount
        }}
      />
      <FormSlider name="progress" onChange={onSlider} />
      <FormInputNumber
        name="orderTotal"
        suffix={quoteCurrency}
        prefix={I18n.t('filledQty')}
        onChange={onOrderTotalChange}
        onFocus={onFocus}
        fieldValid={{
          validateStatus: validState?.totalStatus,
          help: validState?.errorMsgTotal
        }}
      />
      {/* {isLeverage && <FormMarginOption
        type={props.type}
        name="marginSelected"
        onMarginSelected={onMarginSelected}
        getMarginDisabled={getMarginDisabled} />} */}
      {afterItems}
    </Form>
  )
}

export const MaxBuyAvblMessage = (props) => {
  const isPc = useClient()
  const iconRef = useRef()
  const calcOffset = () => {
    const offsetWidth = iconRef?.current?.offsetWidth || 0;
    if (isPc) {
      return [`${offsetWidth * 2}`, '-5']
    }
    return ['0', '7']
  }
  return (
    <div className={styles.wrapper}>
      <span>{props?.errorMsgTotal}</span>
      <Popover
        contenTitle={I18n.t('tip')}
        mode="modal"
        content={<div className={styles.content}>
          <p className={styles.p}>{I18n.t('maxAvailTip11.1')}</p>
          <p className={styles.p}>{I18n.t('maxAvailTip11.2')}</p>
          <p className={styles.p}>{I18n.t('maxAvailTip11.3')}</p>
        </div>}
        destroyTooltipOnHide
        hasArrow
        autoAdjustOverflow={false}
        overlayClassName={styles.popover}
        arrowPointAtCenter
        placement={isPc ? 'bottomRight' : 'topLeft'}
        align={{ offset: calcOffset() }}
      >
        <div className={styles.iconWrapper}>
          <span ref={iconRef} className={cn('icon', 'icon-help', styles.helpIcon)} />
        </div>
      </Popover>
    </div>
  )
}
